var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrassAndTrees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19200 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7698 1001H9618V1220H7698V1001Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8352,
    y: 1023,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8206,
    y: 1049,
    width: 34,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8224,
    y: 1042,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8529,
    y: 1061,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8568,
    y: 1073,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8909,
    y: 1037,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8938,
    y: 1025,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9912 961H11832V1180H9912V961Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10480,
    y: 983,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10371,
    y: 1058,
    width: 34,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10322,
    y: 1007,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10529,
    y: 1027,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10791,
    y: 1065,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11123,
    y: 997,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11152,
    y: 985,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15307 1046H17243V1216H15307V1046Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15966.4,
    y: 1063.08,
    width: 58.4833,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15383.6,
    y: 1077.83,
    width: 58.4833,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16528.1,
    y: 1073.95,
    width: 39.325,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16900.2,
    y: 1064.63,
    width: 39.325,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.5 504C9515.33 489.898 9468.16 545.562 9445.02 554.039C9435.13 557.657 9428.42 561.037 9426.6 561.961C9381.8 584.777 9361.51 622.591 9345.01 649.103C9301.37 719.213 9292.26 697.269 9244.99 770.574C9200.88 838.994 9202.91 867.249 9163.4 889.405C9146.71 898.753 9147.24 893.207 9089.7 915.811C9033.72 937.782 9018.93 948.661 9010.74 955.422C8987.69 974.487 8974.08 996.748 8966 1013.52C9176.56 1010.88 9387.12 1008.24 9597.68 1005.59H9602.94L9599.5 504Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11464 376.875C11357.7 359.068 11298.2 429.363 11268.9 440.068C11256.4 444.637 11248 448.905 11245.7 450.072C11189.1 478.885 11163.5 526.639 11142.6 560.121C11087.5 648.659 11076 620.947 11016.3 713.521C10960.6 799.925 10963.2 835.607 10913.3 863.586C10892.2 875.391 10892.9 868.389 10820.2 896.934C10749.5 924.68 10730.8 938.419 10720.5 946.956C10691.4 971.033 10674.2 999.146 10664 1020.32C10929.9 1016.99 11195.8 1013.65 11461.7 1010.32H11468.4L11464 376.875Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11463.3 376.875C11569.6 359.068 11629.2 429.363 11658.4 440.068C11670.9 444.637 11679.4 448.905 11681.7 450.072C11738.3 478.885 11763.9 526.639 11784.7 560.121C11839.8 648.659 11851.3 620.947 11911 713.521C11966.7 799.925 11964.2 835.607 12014.1 863.586C12035.2 875.391 12034.5 868.389 12107.1 896.934C12177.8 924.68 12196.5 938.419 12206.9 946.956C12236 971.033 12253.2 999.146 12263.4 1020.32C11997.5 1016.99 11731.6 1013.65 11465.6 1010.32H11459L11463.3 376.875Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9597.45 504.277C9681.62 490.176 9728.79 545.84 9751.92 554.316C9761.82 557.934 9768.53 561.314 9770.35 562.238C9815.14 585.054 9835.43 622.868 9851.94 649.381C9895.58 719.491 9904.68 697.546 9951.95 770.852C9996.07 839.271 9994.04 867.527 10033.5 889.682C10050.2 899.03 10049.7 893.485 10107.2 916.089C10163.2 938.059 10178 948.939 10186.2 955.699C10209.3 974.765 10222.9 997.026 10230.9 1013.79C10020.4 1011.15 9809.83 1008.51 9599.27 1005.87H9594L9597.45 504.277Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9600.94 1005.6C9600.94 1005.6 9600.94 759.142 9600.94 635.902C9595.91 635.559 9587.2 635.453 9577.25 638.543C9562.41 643.164 9553.14 652.301 9550.93 654.387C9529.85 674.271 9474.34 689.085 9427.23 712.482C9396.8 727.586 9291.29 780.004 9274.57 847.156C9272.49 855.527 9267.76 880.27 9250.88 886.766C9239.07 891.308 9232.43 882.62 9219.3 886.766C9203.3 891.81 9201.32 908.42 9185.08 929.017C9185.08 929.017 9168.58 949.958 9142.97 963.346C9109.41 980.906 9091.49 967.888 9053.48 981.831C9040.51 986.584 9022.61 995.456 9003.48 1013.52L9600.94 1005.6Z",
    fill: "#28685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11464.5 1010.07C11464.5 1010.07 11464.5 716.166 11464.5 569.2C11458.5 568.791 11448.1 568.665 11436.2 572.349C11418.5 577.86 11407.5 588.756 11404.8 591.244C11379.7 614.956 11313.5 632.622 11257.3 660.522C11221 678.535 11095.2 741.043 11075.3 821.124C11072.8 831.106 11067.2 860.613 11047 868.359C11032.9 873.776 11025 863.415 11009.4 868.359C10990.3 874.374 10987.9 894.181 10968.6 918.744C10968.6 918.744 10948.9 943.716 10918.4 959.681C10878.3 980.623 10857 965.098 10811.6 981.725C10796.2 987.393 10774.8 997.974 10752 1019.51L11464.5 1010.07Z",
    fill: "#28685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11463.9 1010.07C11463.9 1010.07 11463.9 716.166 11463.9 569.2C11469.9 568.791 11480.3 568.665 11492.1 572.349C11509.8 577.86 11520.9 588.756 11523.5 591.244C11548.7 614.956 11614.9 632.622 11671 660.522C11707.3 678.535 11833.2 741.043 11853.1 821.124C11855.6 831.106 11861.2 860.613 11881.3 868.359C11895.4 873.776 11903.3 863.415 11919 868.359C11938.1 874.374 11940.4 894.181 11959.8 918.744C11959.8 918.744 11979.5 943.716 12010 959.681C12050 980.623 12071.4 965.098 12116.7 981.725C12132.2 987.393 12153.5 997.974 12176.4 1019.51L11463.9 1010.07Z",
    fill: "#28685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9598 1005.87C9598 1005.87 9598 759.42 9598 636.18C9603.03 635.836 9611.74 635.731 9621.69 638.82C9636.54 643.441 9645.8 652.578 9648.01 654.664C9669.1 674.549 9724.6 689.363 9771.72 712.759C9802.14 727.864 9907.66 780.281 9924.37 847.434C9926.45 855.804 9931.19 880.548 9948.06 887.044C9959.88 891.586 9966.51 882.898 9979.64 887.044C9995.65 892.087 9997.62 908.697 10013.9 929.294C10013.9 929.294 10030.4 950.235 10056 963.623C10089.5 981.184 10107.5 968.165 10145.5 982.108C10158.4 986.861 10176.3 995.734 10195.5 1013.8L9598 1005.87Z",
    fill: "#28685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11887 993.5C11958 981.001 12111.3 980.137 12228 993.5C12311 1003 12478 1002.5 12568 993.5C12655 984.806 12678.5 979.501 12808.5 961.501C12928.5 944.886 13077 947.501 13156 937.001C13213.4 929.367 13329.2 909.469 13408 923.001C13454.1 930.917 13494.8 933.111 13606 923.001C13729.5 911.77 13869.7 926.1 13935.5 937.001C14014 950.011 14098.1 956.79 14214 937C14296 923 14386.5 902.025 14494.7 911.77C14619.5 923.001 14736.5 954.501 14942.5 936.001C15035.9 935.334 15100 909.77 15223 924C15290 924 15354.8 962.001 15359 961.501V1080H14942.5H11887V993.5Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543 527.789C7629.36 513.322 7681.29 527.22 7705.03 535.917C7715.18 539.628 7722.06 543.096 7723.93 544.045C7769.89 567.452 7790.71 606.249 7807.64 633.45C7852.41 705.38 7861.75 682.866 7910.25 758.075C7955.51 828.272 7953.43 857.261 7993.96 879.991C8011.08 889.582 8010.54 883.893 8069.57 907.084C8127.01 929.625 8142.19 940.787 8150.58 947.723C8174.24 967.283 8188.2 990.122 8196.49 1007.33C7980.46 1004.62 7764.43 1001.91 7548.4 999.198H7543V527.789Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543.48 528.672C7503.19 528.671 7439.95 557.107 7420.45 568.849C7410.3 572.56 7372.67 596.603 7371.35 598.048C7351.44 619.727 7323.12 646.164 7312.95 657.331C7244.82 732.1 7197.48 761.299 7169.16 785.632C7123.9 855.828 7133.06 858.144 7092.53 880.874C7075.41 890.465 7075.95 884.775 7016.92 907.967C6959.48 930.508 6944.3 941.67 6935.91 948.605C6912.25 968.166 6898.29 991.005 6890 1008.21C7106.03 1005.5 7322.06 1002.79 7538.08 1000.08H7543.48V528.672Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543 999.198C7543 999.198 7543 746.343 7543 619.903C7548.16 619.55 7557.1 619.442 7567.31 622.612C7582.54 627.353 7592.04 636.727 7594.31 638.867C7615.94 659.268 7672.89 674.467 7721.23 698.471C7752.44 713.968 7860.7 767.746 7877.85 836.643C7879.98 845.231 7884.84 870.617 7902.15 877.281C7914.28 881.941 7921.08 873.028 7934.55 877.281C7950.97 882.456 7953 899.497 7969.66 920.629C7969.66 920.629 7986.59 942.114 8012.87 955.85C8047.29 973.866 8065.68 960.51 8104.68 974.814C8117.99 979.691 8136.35 988.794 8155.98 1007.33L7543 999.198Z",
    fill: "#28685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543.48 1000.08C7543.48 1000.08 7543.48 747.226 7543.48 620.786C7538.33 620.433 7529.39 620.325 7519.18 623.495C7503.95 628.236 7494.45 637.61 7492.18 639.75C7470.55 660.151 7413.6 675.35 7365.26 699.354C7334.05 714.851 7225.79 768.629 7208.64 837.525C7206.51 846.114 7201.65 871.499 7184.34 878.164C7172.21 882.824 7165.41 873.911 7151.93 878.164C7135.52 883.339 7133.49 900.38 7116.83 921.512C7116.83 921.512 7099.9 942.997 7073.62 956.732C7039.19 974.749 7020.8 961.392 6981.81 975.697C6968.5 980.574 6950.14 989.677 6930.5 1008.21L7543.48 1000.08Z",
    fill: "#28685B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5896 865C5856 866.2 5759 878.833 5716 882.5V1079.5H7486C7499.67 941.167 7518.8 667.001 7486 677.001C7445 689.501 7111 809 7072 835.5C7033 862 6708 909.5 6638 919.5C6607.64 923.836 6347.5 919.5 6233.5 907.5C6215.1 905.563 5946 863.5 5896 865Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7684.29 641C7498.7 643.909 7449.07 693.532 7419.5 734.5C7415.84 739.583 7367.47 769.109 7339.43 809.404C7279.5 862.5 7257.8 879.488 7245.5 889.5C7206.86 921.037 7223.37 907.66 7150.22 944.127C7106.54 965.897 7062.81 996.852 7046.45 1008.43C7039.34 1013.45 7019.57 1027.62 6991.52 1045.17C6978.79 1053.13 6968.14 1059.41 6961 1063.54C7203.1 1061.49 7442.18 1065.59 7684.29 1063.54V641Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7600.5 797C7567.85 806.461 7542.21 821.464 7530.31 833.743C7504.28 860.595 7507.58 881.661 7481.48 898.042C7457.8 912.923 7450.48 898.41 7417.39 913.352C7394.78 923.548 7392.25 933.009 7347.2 959.28C7336.95 965.25 7321.48 973.885 7307.53 968.465C7300.42 965.71 7301.06 962.189 7295.32 959.28C7274.9 948.992 7247.9 984.05 7194.61 1002.15C7183.29 1005.97 7173.25 1008.27 7173.25 1008.27C7148.8 1013.81 7141.69 1010.6 7127.47 1014.39C7105.53 1020.24 7107.51 1031.91 7084.74 1041.95C7080.35 1043.88 7073.94 1046.27 7026.76 1048.07C6983.33 1049.76 6973.66 1048.32 6956.57 1054.2C6941.25 1059.46 6929.93 1067.15 6923 1072.57C7148.83 1073.58 7374.67 1074.62 7600.5 1075.63V797Z",
    fill: "#8DC97E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7436.54 1069.5C7434.74 1061.51 7426.62 1030.03 7396.87 1011.32C7391.4 1007.89 7375.75 998.036 7357.19 999.077C7326.61 1000.79 7297.65 1031.59 7287 1075.62H7436.54V1069.5Z",
    fill: "#05A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.5 951.5C732.5 919.9 219.5 904 -5 900V1079.5H1984V900C1928.8 900 1662 934.333 1535.5 951.5C1459.83 964.667 1244.5 983.1 988.5 951.5Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2962.5 951.5C2706.5 919.9 2193.5 904 1969 900V1079.5H3958C3958 1069.67 3976.5 1020 3976.5 892C3921.3 892 3636 934.333 3509.5 951.5C3433.83 964.667 3218.5 983.1 2962.5 951.5Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.995 974.281C405.444 968.883 856.769 1042.51 1062 1080H-0.5H-119C-110.703 1074.51 -68.2794 1047.73 -0.5 1022.44C61.4067 999.347 144.466 977.503 241.995 974.281Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.65 988.376C1851.49 997.398 1663.23 1115.69 1642 1129.72H3221C2946.61 1079.6 2343.18 981.158 2124.65 988.376Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4594.66 915.494C4509.67 887.76 4138.5 869.5 3958 893V1080.07H5954V871.813C5796.2 837.838 5651.71 846.406 5580.89 853.34C5510.06 860.273 5356.34 862.106 5073.66 915.494C4790.98 968.882 4700.89 950.162 4594.66 915.494Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5442.89 1033.77)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5449.55 1037.47)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5448.46 1044.03)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5440.72 1046.91)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5436.59 1040.52)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5444.42 1040.25)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4698.05 1043.08C4655.35 1058.12 4312 1062.19 4292 1079H4390.5H5955.5V927C5893.26 934.24 5721.76 964.388 5589.74 967.061C5424.72 970.402 5317 1033.05 5242.5 1024.5C5218.05 1021.69 5095.41 1043.08 4990.46 1033.05C4885.51 1023.03 4740.76 1028.04 4698.05 1043.08Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6078 1020)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6079 1024)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6076 1026)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6072 1024)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6073 1020)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 6076 1023)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6284 1006)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6285 1010)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6282 1012)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6278 1010)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6279 1006)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 6282 1009)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6541.71,
    cy: 1019,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6540.71,
    cy: 1023,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6543.71,
    cy: 1025,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6547.71,
    cy: 1023,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6546.71,
    cy: 1019,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6543.71,
    cy: 1022,
    r: 2,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6162.46 994.881)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6168.31 999.758)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6166.01 1006.01)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6157.87 1007.38)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6155.01 1000.32)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6162.75 1001.53)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6098.24 969.827)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6104.08 974.704)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6101.79 980.951)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6093.65 982.323)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6090.78 975.269)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6098.52 976.478)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6343.62 1032.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6345.46 1039.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6339.92 1043.62)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6332.54 1039.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6334.39 1032.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 6339.92 1038.08)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6485.38,
    cy: 1037.54,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6483.54,
    cy: 1044.92,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6489.08,
    cy: 1048.62,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6496.46,
    cy: 1044.92,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6494.61,
    cy: 1037.54,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6489.08,
    cy: 1043.08,
    r: 3.69231,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6385.15 1001.38)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6386.62 1007.23)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6382.23 1010.15)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6376.38 1007.23)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6377.85 1001.38)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 6382.23 1005.77)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6428.85,
    cy: 1021.38,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6427.38,
    cy: 1027.23,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6431.77,
    cy: 1030.15,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6437.62,
    cy: 1027.23,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6436.15,
    cy: 1021.38,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6431.77,
    cy: 1025.77,
    r: 2.92308,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6214.11 1024.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6220.76 1028.62)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6219.68 1035.18)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6211.94 1038.06)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6207.8 1031.67)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6215.63 1031.4)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6025.62 985.538)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6027.46 992.923)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6021.92 996.616)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6014.54 992.923)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6016.39 985.538)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 6021.92 991.077)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6001.62 1028.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6003.46 1035.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5997.92 1039.62)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5990.54 1035.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5992.39 1028.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 5997.92 1034.08)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7212.45 1043.08C7255.15 1058.12 7598.5 1062.19 7618.5 1079H7520H5955V927C6017.24 934.24 6188.74 964.388 6320.76 967.061C6485.78 970.402 6593.5 1033.05 6668 1024.5C6692.45 1021.69 6815.09 1043.08 6920.04 1033.05C7024.99 1023.03 7169.74 1028.04 7212.45 1043.08Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4068.55 979.874C4090.59 969.803 4125.56 957.498 4166.21 949.264V949.541C4206.77 957.774 4241.66 969.555 4263.66 979.609C4301.26 996.781 4327.32 1009.12 4343.01 1037.77C4352.53 1055.16 4354.79 1072.27 4355.21 1083.68C4334.19 1083.68 4306.48 1084.49 4278.78 1085.3C4224.56 1086.88 4170.35 1088.47 4166.2 1083.98C4163.95 1088.79 4108.69 1087.18 4053.43 1085.57C4025.73 1084.76 3998.03 1083.95 3977 1083.95C3977.43 1072.53 3979.69 1055.42 3989.21 1038.03C4004.89 1009.38 4030.96 997.047 4068.55 979.874Z",
    fill: "#D19DCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4338 1073.48C4339.8 1065.49 4347.92 1034.02 4377.67 1015.32C4383.14 1011.89 4398.79 1002.04 4417.35 1003.08C4447.93 1004.79 4476.89 1035.59 4487.54 1079.6H4338V1073.48Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11754 1062.48C11755.8 1054.49 11763.9 1023.02 11793.7 1004.32C11799.1 1000.89 11814.8 991.036 11833.3 992.077C11863.9 993.791 11892.9 1024.59 11903.5 1068.6H11754V1062.48Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9600.38 723.824C9440.33 726.333 9378.48 762.431 9352.97 797.763C9349.82 802.147 9327.15 834.31 9302.97 869.061C9260.67 929.797 9258.3 934.365 9247.69 943C9214.37 970.199 9202.87 953.801 9139.78 985.251C9102.12 1004.03 9064.4 1030.72 9050.29 1040.71C9044.16 1045.04 9027.11 1057.26 9002.92 1072.39C8991.94 1079.26 8982.76 1084.67 8976.6 1088.24C9185.39 1086.47 9391.59 1090.01 9600.38 1088.24V723.824Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9600 723.43C9760.05 725.938 9821.9 762.036 9847.41 797.369C9850.57 801.752 9873.23 833.916 9897.42 868.667C9939.71 929.402 9942.08 933.971 9952.69 942.606C9986.01 969.805 9997.51 953.406 10060.6 984.856C10098.3 1003.63 10136 1030.33 10150.1 1040.31C10156.2 1044.64 10173.3 1056.87 10197.5 1072C10208.4 1078.86 10217.6 1084.28 10223.8 1087.84C10015 1086.07 9808.8 1089.61 9600 1087.84V723.43Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.71 844.195C9571.55 852.355 9549.44 865.294 9539.18 875.883C9516.73 899.042 9519.57 917.21 9497.07 931.338C9476.64 944.171 9470.32 931.654 9441.79 944.541C9422.29 953.334 9420.11 961.494 9381.26 984.151C9372.41 989.3 9359.07 996.747 9347.04 992.073C9340.91 989.696 9341.46 986.66 9336.51 984.151C9318.91 975.278 9295.61 1005.51 9249.66 1021.12C9239.89 1024.42 9231.23 1026.4 9231.23 1026.4C9210.15 1031.18 9204.02 1028.41 9191.75 1031.68C9172.83 1036.73 9174.54 1046.79 9154.91 1055.45C9151.12 1057.11 9145.59 1059.17 9104.9 1060.73C9067.44 1062.18 9059.1 1060.94 9044.36 1066.01C9031.15 1070.55 9021.38 1077.18 9015.41 1081.86C9210.18 1082.73 9404.95 1083.63 9599.71 1084.5V844.195Z",
    fill: "#8DC97E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.72 965.67C9564.66 972.773 9534.49 983.389 9515.49 992.077C9483.06 1006.89 9460.59 1017.53 9447.06 1042.25C9438.85 1057.25 9436.9 1072.01 9436.53 1081.86C9490.93 1081.86 9545.31 1081.86 9599.72 1081.86V965.67Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9434.97 1076.8C9433.42 1069.91 9426.41 1042.76 9400.75 1026.63C9396.04 1023.67 9382.54 1015.17 9366.54 1016.07C9340.16 1017.54 9315.19 1044.11 9306 1082.08H9434.97V1076.8Z",
    fill: "#05A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9410.14 870.744C9371.39 869.35 9363.91 880.051 9343.66 877.177C9310.36 872.438 9279.68 836.242 9272.9 797.837C9272.32 794.556 9264.15 744.893 9290.06 722.785C9297.58 716.352 9306.72 713.35 9313.64 701.342C9320.55 689.355 9319.54 678.333 9320.08 671.321C9322.37 641.365 9358.93 607.12 9397.27 600.558C9453.95 590.844 9494.86 644.946 9500.2 652.022C9536.7 700.291 9525.76 756.387 9523.79 765.672C9530.05 768.181 9537.88 772.641 9543.09 780.682C9556.87 801.954 9544.29 835.62 9525.93 853.59C9502.97 876.062 9469.43 875.419 9448.74 875.033C9430.9 874.69 9431.09 871.495 9410.14 870.744Z",
    fill: "#3C7474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9279.33 799.983C9283.04 798.225 9288.12 807.875 9296.49 806.416C9302.25 805.409 9306.44 799.683 9309.35 795.695C9314.54 788.597 9313.79 784.737 9317.93 782.829C9323.14 780.427 9327.13 785.209 9330.8 782.829C9335.3 779.912 9330.6 771.914 9335.08 763.53C9338.73 756.711 9347.54 751.307 9354.38 752.808C9360.77 754.202 9360.79 760.613 9369.39 763.53C9371.07 764.087 9377.05 766.103 9382.26 763.53C9388.84 760.27 9386.87 753.344 9392.98 748.519C9399.63 743.266 9411.23 744.145 9418.71 748.519C9427.87 753.859 9426.67 761.964 9433.72 763.53C9438.91 764.688 9440.91 760.592 9455.17 754.952C9464.07 751.436 9468.5 749.677 9472.32 750.664C9482.1 753.215 9487.83 767.475 9489.48 776.396C9490.7 782.957 9489.33 784.673 9491.62 789.262C9495.54 797.131 9504.04 801.034 9506.63 802.128C9514.01 805.216 9516.86 803.286 9519.5 806.416C9523.72 811.456 9517.67 818.017 9521.64 823.571C9525.39 828.825 9532.68 825.587 9538.8 832.148C9543.08 842.87 9509.68 867.444 9506.63 868.602C9466.62 883.827 9451.78 869.953 9380.12 875.035C9359.21 876.515 9346.56 878.681 9328.65 872.891C9321.94 870.725 9303.13 860.732 9290.05 838.581C9279.82 821.277 9274.36 802.342 9279.33 799.983Z",
    fill: "#3B606C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9282.87 816.255C9285.12 813.982 9289.95 814.261 9293.06 816.255C9296.77 818.635 9295.84 822.109 9299.17 828.65C9300.6 831.48 9305.15 839.414 9313.41 843.102C9317.22 844.818 9320.35 844.946 9325.61 845.161C9334.57 845.547 9336.95 843.617 9345.96 843.102C9353.29 842.673 9359.62 842.287 9366.31 845.161C9374.37 848.613 9373.51 852.709 9382.58 857.555C9386.7 859.742 9394.89 864.117 9402.93 861.694C9411.7 859.035 9411.12 851.058 9419.21 849.299C9424.14 848.227 9429.26 850.65 9439.56 855.497C9447.17 859.078 9448.59 860.922 9453.8 861.694C9456.24 862.058 9462.5 862.98 9468.03 859.635C9474 856.054 9472.3 851.658 9478.22 847.241C9484.18 842.781 9491.62 842.974 9496.53 843.102C9503.42 843.295 9503.91 845.032 9508.73 845.161C9523.1 845.59 9531.79 830.601 9535.2 832.767C9537.98 834.525 9536.97 847.498 9529.08 857.534C9519.73 869.435 9497.63 872.501 9453.77 878.184C9446.48 879.127 9440.84 879.749 9435.46 880.242C9428.06 880.928 9412.39 882.365 9394.76 882.301C9377.22 882.236 9358.63 882.194 9335.73 876.104C9321.68 872.372 9312.55 869.821 9303.16 861.651C9292.41 852.302 9288.25 841.58 9284.84 832.745C9282.42 826.377 9279.78 819.365 9282.87 816.255Z",
    fill: "#3C4D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9474.49 819.579L9421.22 878.377C9418.44 881.443 9413.7 881.679 9410.63 878.891C9407.57 876.104 9407.33 871.365 9410.12 868.298L9463.36 809.501C9466.15 806.434 9470.89 806.198 9473.95 808.986C9477.04 811.752 9477.28 816.513 9474.49 819.579Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9460.92 752.44L9419.4 789.172C9416.29 791.917 9411.55 791.638 9408.81 788.529C9406.06 785.42 9406.34 780.681 9409.45 777.936L9450.97 741.204C9454.08 738.459 9458.81 738.738 9461.56 741.847C9464.33 744.956 9464.03 749.695 9460.92 752.44Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9404.11 842.568L9343.94 782.419C9341 779.482 9341 774.743 9343.94 771.805C9346.88 768.867 9351.62 768.867 9354.56 771.805L9414.73 831.975C9417.66 834.913 9417.66 839.652 9414.73 842.589C9411.79 845.506 9407.03 845.506 9404.11 842.568Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9412.28 1053.01C9408.72 1053.01 9405.85 1050.14 9405.85 1046.58V750.658C9405.85 747.098 9408.72 744.225 9412.28 744.225C9415.84 744.225 9418.72 747.098 9418.72 750.658V1046.58C9418.72 1050.14 9415.84 1053.01 9412.28 1053.01Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11643.8 795C11610.2 804.731 11583.8 820.161 11571.6 832.789C11544.8 860.406 11548.2 882.071 11521.4 898.918C11497 914.223 11489.5 899.296 11455.5 914.664C11432.2 925.15 11429.6 934.88 11383.3 961.899C11372.7 968.04 11356.8 976.92 11342.5 971.346C11335.2 968.512 11335.8 964.891 11329.9 961.899C11308.9 951.318 11281.1 987.375 11226.3 1005.99C11214.7 1009.92 11204.4 1012.28 11204.4 1012.28C11179.2 1017.98 11171.9 1014.68 11157.3 1018.58C11134.7 1024.6 11136.8 1036.59 11113.4 1046.92C11108.8 1048.91 11102.2 1051.36 11053.7 1053.22C11009.1 1054.95 10999.1 1053.47 10981.5 1059.52C10965.8 1064.94 10954.1 1072.84 10947 1078.41C11179.3 1079.45 11411.5 1080.52 11643.8 1081.56V795Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11643.8 939.858C11602 948.329 11566 960.989 11543.4 971.349C11504.7 989.015 11477.9 1001.71 11461.7 1031.18C11452 1049.07 11449.6 1066.67 11449.2 1078.42C11514.1 1078.42 11578.9 1078.42 11643.8 1078.42V939.858Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11447.3 1072.39C11445.5 1064.17 11437.1 1031.8 11406.5 1012.55C11400.9 1009.03 11384.8 998.888 11365.7 999.959C11334.3 1001.72 11304.5 1033.4 11293.5 1078.68H11447.3V1072.39Z",
    fill: "#05A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11638.6 795C11672.2 804.731 11698.5 820.161 11710.8 832.789C11737.5 860.406 11734.1 882.071 11761 898.918C11785.3 914.223 11792.9 899.296 11826.9 914.664C11850.2 925.15 11852.8 934.88 11899.1 961.899C11909.6 968.04 11925.5 976.92 11939.9 971.346C11947.2 968.512 11946.5 964.891 11952.4 961.899C11973.4 951.318 12001.2 987.375 12056 1005.99C12067.7 1009.92 12078 1012.28 12078 1012.28C12103.1 1017.98 12110.4 1014.68 12125.1 1018.58C12147.6 1024.6 12145.6 1036.59 12169 1046.92C12173.5 1048.91 12180.1 1051.36 12228.7 1053.22C12273.3 1054.95 12283.3 1053.47 12300.8 1059.52C12316.6 1064.94 12328.2 1072.84 12335.4 1078.41C12103.1 1079.45 11870.8 1080.52 11638.6 1081.56V795Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11638.6 940.859C11680.4 949.33 11716.3 961.989 11739 972.35C11777.7 990.016 11804.5 1002.71 11820.6 1032.18C11830.4 1050.07 11832.7 1067.67 11833.2 1079.42C11768.3 1079.42 11703.4 1079.42 11638.6 1079.42V940.859Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11835 1072.39C11836.9 1064.17 11845.2 1031.8 11875.8 1012.55C11881.5 1009.03 11897.6 998.888 11916.6 999.959C11948.1 1001.72 11977.9 1033.4 11988.8 1078.68H11835V1072.39Z",
    fill: "#05A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.67 842.801C9627.83 850.96 9649.94 863.9 9660.21 874.489C9682.66 897.648 9679.81 915.815 9702.32 929.943C9722.74 942.777 9729.06 930.26 9757.59 943.146C9777.09 951.94 9779.28 960.1 9818.12 982.756C9826.97 987.906 9840.31 995.352 9852.34 990.678C9858.47 988.302 9857.92 985.265 9862.87 982.756C9880.48 973.884 9903.77 1004.12 9949.72 1019.73C9959.49 1023.03 9968.15 1025.01 9968.15 1025.01C9989.23 1029.79 9995.36 1027.01 10007.6 1030.29C10026.6 1035.33 10024.8 1045.39 10044.5 1054.05C10048.3 1055.72 10053.8 1057.78 10094.5 1059.34C10131.9 1060.79 10140.3 1059.55 10155 1064.62C10168.2 1069.16 10178 1075.79 10184 1080.46C9989.2 1081.33 9794.44 1082.23 9599.67 1083.1V842.801Z",
    fill: "#8DC97E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.67 964.275C9634.73 971.379 9664.89 981.994 9683.89 990.682C9716.32 1005.5 9738.8 1016.14 9752.32 1040.86C9760.54 1055.85 9762.48 1070.62 9762.85 1080.47C9708.45 1080.47 9654.07 1080.47 9599.67 1080.47V964.275Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9764.41 1075.41C9765.97 1068.51 9772.97 1041.37 9798.63 1025.23C9803.34 1022.28 9816.84 1013.77 9832.85 1014.67C9859.22 1016.15 9884.2 1042.72 9893.38 1080.69H9764.41V1075.41Z",
    fill: "#05A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.02 708.016C7753.22 710.589 7816.68 747.625 7842.85 783.875C7846.09 788.372 7869.34 821.371 7894.16 857.024C7937.55 919.337 7939.98 924.024 7950.86 932.883C7985.05 960.789 7996.85 943.964 8061.58 976.231C8100.22 995.494 8138.92 1022.88 8153.39 1033.13C8159.68 1037.57 8177.18 1050.11 8202 1065.64C8213.26 1072.68 8222.68 1078.23 8229 1081.89C8014.78 1080.08 7803.23 1083.71 7589.02 1081.89V708.016Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.02 838.059C7617.91 846.43 7640.59 859.705 7651.12 870.57C7674.16 894.33 7671.24 912.969 7694.33 927.464C7715.28 940.631 7721.76 927.789 7751.04 941.01C7771.05 950.032 7773.29 958.403 7813.14 981.649C7822.22 986.932 7835.91 994.572 7848.25 989.777C7854.54 987.338 7853.97 984.223 7859.05 981.649C7877.12 972.546 7901.01 1003.57 7948.16 1019.58C7958.18 1022.96 7967.06 1025 7967.06 1025C7988.69 1029.9 7994.99 1027.06 8007.57 1030.42C8026.99 1035.59 8025.23 1045.91 8045.38 1054.8C8049.26 1056.51 8054.93 1058.62 8096.68 1060.22C8135.11 1061.71 8143.67 1060.43 8158.79 1065.64C8172.35 1070.3 8182.36 1077.1 8188.49 1081.89C7988.67 1082.79 7788.84 1083.71 7589.02 1084.6V838.059Z",
    fill: "#8DC97E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.02 965.689C7624.98 972.977 7655.93 983.869 7675.43 992.782C7708.7 1007.98 7731.76 1018.9 7745.64 1044.26C7754.06 1059.65 7756.06 1074.79 7756.44 1084.9C7700.62 1084.9 7644.83 1084.9 7589.02 1084.9V965.689Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7761.84 1076.48C7763.43 1069.41 7770.61 1041.56 7796.94 1025C7801.78 1021.97 7815.63 1013.25 7832.05 1014.17C7859.1 1015.68 7884.73 1042.94 7894.16 1081.9H7761.84V1076.48Z",
    fill: "#05A556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7570.24 895.169C7595.95 889.992 7601.79 895.941 7617.3 892.415C7638.39 887.623 7656.22 870.108 7664.35 851.104C7671.72 833.892 7675.62 804.864 7661.59 793.269C7648.24 782.253 7630.8 796.905 7614.53 785.007C7600.55 774.789 7607.66 759.752 7595.15 746.45C7578.32 728.549 7540.65 729.43 7514.87 743.696C7477.62 764.324 7473.96 808.031 7473.35 815.302C7471.08 842.347 7479.5 882.198 7506.57 895.169C7521.93 902.55 7542.58 900.925 7545.32 900.678C7555.51 899.796 7557.84 897.676 7570.24 895.169Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7785.63 809.905C7756.21 808.393 7750.92 815.121 7741.76 809.905C7726.21 801.056 7732.4 776.436 7717.38 770.903C7710.41 768.344 7706.76 772.804 7697.88 773.341C7675.87 774.681 7649.94 750.086 7641.82 722.151C7633.31 692.851 7644.79 661.186 7666.2 644.147C7675.19 636.981 7684.43 633.617 7690.57 631.959C7680.58 595.566 7691.96 576.26 7695.45 571.019C7710.51 548.422 7741.56 542.84 7788.07 534.455C7801.79 531.993 7807.08 531.944 7810.01 532.017C7812.59 532.066 7857.15 533.699 7875.82 563.706C7888.49 584.085 7883.42 608.168 7892.88 610.021C7896.98 610.825 7898.27 606.389 7905.07 605.146C7918.13 602.757 7936.02 615.018 7939.19 629.522C7941.97 642.27 7932.39 652.216 7936.75 656.335C7940.51 659.894 7948.04 652.85 7956.25 653.898C7975.27 656.311 7998.25 702.162 7983.07 739.214C7974.8 759.373 7954.08 779.752 7931.88 780.653C7915.35 781.312 7903.22 770.952 7892.88 778.216C7885.98 783.067 7889.27 789.161 7883.13 797.717C7868.9 817.559 7830.02 814.244 7807.57 812.342C7796.75 811.416 7796.43 810.441 7785.63 809.905Z",
    fill: "#3C7474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7646.7 724.588C7642.8 734.216 7654.01 748.964 7668.63 761.152C7688.55 777.752 7707.63 773.34 7714.95 770.902C7726.62 767.002 7729.45 795.083 7736.88 805.029C7746.36 817.753 7750.87 807.856 7817.32 812.342C7856.46 814.999 7867.75 816.144 7875.82 807.466C7885.08 797.521 7884.96 780.214 7895.32 778.215C7899.02 777.508 7901.7 779.214 7905.07 780.653C7924.54 788.989 7954.4 782.846 7958.69 770.902C7961.59 762.809 7953.72 749.476 7944.07 746.526C7933.59 743.333 7925.01 753.668 7917.25 748.964C7912.6 746.136 7914.48 741.675 7909.94 734.338C7901.46 720.663 7880.4 712.887 7870.94 719.712C7868.02 721.809 7869.14 725.465 7866.07 727.025C7860.95 729.633 7852.91 723.344 7851.44 722.15C7839.99 712.887 7843.2 702.527 7834.38 690.461C7824.95 677.517 7809.96 673.934 7807.57 673.398C7786.83 668.718 7762.16 679.516 7758.82 692.899C7757.45 698.359 7759.97 703.064 7756.38 709.962C7753.73 715.057 7749.39 717.884 7746.63 719.712C7744.66 721.029 7738.15 725.392 7730.79 725.806C7718.99 726.489 7717.07 716.324 7701.54 711.181C7688.96 707.012 7677.58 709.499 7669.85 711.181C7658.59 713.618 7649.33 718.079 7646.7 724.588Z",
    fill: "#3B606C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7875.84 761.469L7815.3 828.308C7812.13 831.794 7806.74 832.062 7803.26 828.893C7799.77 825.724 7799.5 820.337 7802.67 816.851L7863.22 750.012C7866.39 746.526 7871.77 746.258 7875.26 749.427C7878.74 752.596 7879.01 757.983 7875.84 761.469Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7860.41 685.171L7813.22 726.928C7809.69 730.048 7804.3 729.731 7801.18 726.196C7798.06 722.662 7798.38 717.275 7801.91 714.155L7849.1 672.398C7852.64 669.278 7858.02 669.595 7861.14 673.13C7864.29 676.664 7863.95 682.051 7860.41 685.171Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7795.85 787.626L7727.45 719.227C7724.11 715.888 7724.11 710.5 7727.45 707.161C7730.79 703.821 7736.18 703.821 7739.52 707.161L7807.91 775.56C7811.25 778.9 7811.25 784.287 7807.91 787.626C7804.57 790.942 7799.16 790.942 7795.85 787.626Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7805.13 1026.85C7801.09 1026.85 7797.82 1023.59 7797.82 1019.54V683.152C7797.82 679.105 7801.09 675.839 7805.13 675.839C7809.18 675.839 7812.45 679.105 7812.45 683.152V1019.54C7812.45 1023.56 7809.15 1026.85 7805.13 1026.85Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8068.04 968.694C8045.57 964.17 8040.47 969.367 8026.92 966.287C8008.49 962.1 7992.92 946.796 7985.81 930.192C7979.37 915.153 7975.96 889.79 7988.23 879.659C7999.88 870.034 8015.12 882.836 8029.34 872.44C8041.56 863.513 8035.34 850.374 8046.27 838.752C8060.98 823.111 8093.9 823.881 8116.41 836.345C8148.97 854.369 8152.16 892.557 8152.69 898.91C8154.68 922.54 8147.32 957.36 8123.67 968.694C8110.24 975.143 8092.2 973.723 8089.81 973.506C8080.91 972.736 8078.88 970.883 8068.04 968.694Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8105.9 930.519L8075.85 963.697C8074.28 965.427 8071.6 965.56 8069.87 963.987C8068.14 962.414 8068.01 959.74 8069.58 958.01L8099.62 924.832C8101.2 923.102 8103.87 922.969 8105.6 924.542C8107.34 926.103 8107.48 928.789 8105.9 930.519Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8066.2 943.494L8032.24 909.554C8030.59 907.896 8030.59 905.222 8032.24 903.565C8033.9 901.907 8036.57 901.907 8038.23 903.565L8072.18 937.517C8073.84 939.174 8073.84 941.848 8072.18 943.506C8070.53 945.152 8067.84 945.152 8066.2 943.494Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8070.81 1062.24C8068.8 1062.24 8067.18 1060.62 8067.18 1058.61V891.63C8067.18 889.621 8068.8 888 8070.81 888C8072.82 888 8074.44 889.621 8074.44 891.63V1058.61C8074.44 1060.62 8072.82 1062.24 8070.81 1062.24Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9163.76 963.823C9152.47 959.371 9145.03 967.205 9136.12 965.964C9117.43 963.352 9109.32 923.131 9108.47 918.872C9104.69 900.12 9103.16 865.721 9119.11 856.795C9124.21 853.948 9130.36 854.098 9133.99 848.233C9137.73 842.175 9133.86 837.658 9136.12 831.108C9140.07 819.613 9159.4 812.036 9174.4 816.124C9180.07 817.666 9185.47 820.983 9195.66 833.249C9211.52 852.321 9221.18 863.923 9225.43 882.482C9232.15 911.743 9222.69 946.142 9202.04 961.683C9198.38 964.444 9185.67 973.991 9174.4 970.245C9169.57 968.64 9169.23 965.985 9163.76 963.823Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9764.79 991.819C9753.5 987.367 9746.06 995.202 9737.15 993.96C9718.46 991.349 9710.36 951.127 9709.5 946.868C9705.72 928.116 9704.19 893.717 9720.14 884.791C9725.24 881.944 9731.39 882.094 9735.02 876.229C9738.77 870.171 9734.9 865.655 9737.15 859.104C9741.1 847.61 9760.43 840.032 9775.43 844.12C9781.1 845.662 9786.51 848.98 9796.69 861.245C9812.56 880.317 9822.21 891.919 9826.46 910.478C9833.18 939.74 9823.72 974.138 9803.07 989.679C9799.41 992.44 9786.7 1001.99 9775.43 998.241C9770.6 996.636 9770.26 993.981 9764.79 991.819Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9194.99 935.98L9169.07 964.594C9167.72 966.086 9165.41 966.201 9163.92 964.844C9162.43 963.488 9162.31 961.182 9163.67 959.689L9189.58 931.076C9190.94 929.584 9193.24 929.469 9194.73 930.825C9196.24 932.172 9196.35 934.488 9194.99 935.98Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9160.75 947.17L9131.47 917.899C9130.04 916.469 9130.04 914.163 9131.47 912.733C9132.9 911.304 9135.2 911.304 9136.63 912.733L9165.91 942.015C9167.34 943.444 9167.34 945.751 9165.91 947.18C9164.48 948.599 9162.17 948.599 9160.75 947.17Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9164.73 1049.58C9162.99 1049.58 9161.6 1048.18 9161.6 1046.45V902.439C9161.6 900.707 9162.99 899.309 9164.73 899.309C9166.46 899.309 9167.86 900.707 9167.86 902.439V1046.45C9167.86 1048.18 9166.46 1049.58 9164.73 1049.58Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9796.03 963.977L9770.1 992.59C9768.75 994.082 9766.44 994.197 9764.95 992.84C9763.46 991.484 9763.34 989.178 9764.7 987.685L9790.61 959.072C9791.97 957.58 9794.27 957.465 9795.77 958.821C9797.27 960.168 9797.38 962.484 9796.03 963.977Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9761.78 975.166L9732.5 945.895C9731.07 944.465 9731.07 942.159 9732.5 940.729C9733.93 939.3 9736.23 939.3 9737.66 940.729L9766.94 970.011C9768.37 971.44 9768.37 973.747 9766.94 975.176C9765.52 976.596 9763.2 976.596 9761.78 975.166Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9765.76 1077.57C9764.03 1077.57 9762.63 1076.17 9762.63 1074.44V930.435C9762.63 928.703 9764.03 927.305 9765.76 927.305C9767.49 927.305 9768.89 928.703 9768.89 930.435V1074.44C9768.89 1076.17 9767.49 1077.57 9765.76 1077.57Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17065.5 984.951C17091.8 976.179 17368.5 923.998 17438 914.998L17446 1106L16406 1118V1099.72C16418.9 1098.02 16449.3 1091.83 16467.4 1080.72C16490.1 1066.83 16545.7 1055.86 16580 1055.86C16614.4 1055.86 16696.3 1050.74 16753.3 1030.28C16810.3 1009.81 16891.5 1011.27 16938.3 1009.81C16985.1 1008.34 17032.6 995.917 17065.5 984.951Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18429.5 964.5C18685.5 932.9 18975 904.5 19199.5 900.5L19423 1092.5H17434C17434 1082.67 17438 1043 17438 915C17506 909 17756 947.333 17882.5 964.5C17958.2 977.667 18173.5 996.1 18429.5 964.5Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19111 987.281C19315.3 994.029 19456.1 1082.5 19472 1093H18291C18496.2 1055.51 18947.6 981.883 19111 987.281Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15918.2 1045.11C15916 1035.37 15874.7 1023.58 15847.1 999.527C15840.5 995.349 15797.4 989.919 15774.9 991.187C15737.9 993.276 15691.9 1000.5 15679 1054.14L15936 1101L15918.2 1045.11Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15932.6 1059.17C15915.5 1037.4 15893.7 1064.24 15885 1080.38L15922.5 1088H15961C15961 1080.38 15949.8 1080.93 15932.6 1059.17Z",
    fill: "#F988CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15509.5 1013.5C15491.5 1007.5 15399.7 975 15356 959.5L15350.5 1104.5H15960.5V1092C15951.7 1090.83 15930.9 1086.6 15918.5 1079C15903 1069.5 15865 1062 15841.5 1062C15818 1062 15762 1058.5 15723 1044.5C15684 1030.5 15628.5 1031.5 15596.5 1030.5C15564.5 1029.5 15532 1021 15509.5 1013.5Z",
    fill: "#54B176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16879 1074C16877 1065.03 16856 1033 16830.4 1010.83C16824.3 1006.98 16806.7 995.918 16785.9 997.086C16751.5 999.01 16719 1033.58 16707 1083L16916.5 1126.5L16879 1074Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5822,
    cy: 1029,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5821,
    cy: 1033,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5824,
    cy: 1035,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5828,
    cy: 1033,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5827,
    cy: 1029,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5824,
    cy: 1032,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5616,
    cy: 1015,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5615,
    cy: 1019,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5618,
    cy: 1021,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5622,
    cy: 1019,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5621,
    cy: 1015,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5618,
    cy: 1018,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5358.29 1028)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5359.29 1032)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5356.29 1034)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5352.29 1032)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5353.29 1028)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 5356.29 1031)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5220 1060)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5221 1064)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5218 1066)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5214 1064)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5215 1060)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 5218 1063)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5737.54,
    cy: 1003.88,
    r: 5.53846,
    transform: "rotate(36.1252 5737.54 1003.88)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5731.69,
    cy: 1008.76,
    r: 5.53846,
    transform: "rotate(36.1252 5731.69 1008.76)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5733.99,
    cy: 1015.01,
    r: 5.53846,
    transform: "rotate(36.1252 5733.99 1015.01)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5742.13,
    cy: 1016.38,
    r: 5.53846,
    transform: "rotate(36.1252 5742.13 1016.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5744.99,
    cy: 1009.32,
    r: 5.53846,
    transform: "rotate(36.1252 5744.99 1009.32)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5737.25,
    cy: 1010.53,
    r: 3.69231,
    transform: "rotate(36.1252 5737.25 1010.53)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5556.38,
    cy: 1041.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5554.54,
    cy: 1048.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5560.08,
    cy: 1052.62,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5567.46,
    cy: 1048.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5565.61,
    cy: 1041.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5560.08,
    cy: 1047.08,
    r: 3.69231,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5414.62 1046.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5416.46 1053.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5410.92 1057.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5403.54 1053.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5405.39 1046.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 5410.92 1052.08)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5057.72,
    cy: 1064.54,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5056.54,
    cy: 1069.26,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5060.08,
    cy: 1071.62,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5064.79,
    cy: 1069.26,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5063.61,
    cy: 1064.54,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5060.08,
    cy: 1068.08,
    r: 2.35897,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5514.85,
    cy: 1010.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5513.38,
    cy: 1016.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5517.77,
    cy: 1019.15,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5523.62,
    cy: 1016.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5522.15,
    cy: 1010.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5517.77,
    cy: 1014.77,
    r: 2.92308,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4916.5 1050.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4917.67 1055.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4914.17 1057.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4909.5 1055.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4910.67 1050.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.33336,
    transform: "matrix(-1 0 0 1 4914.17 1054)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4664.5 1069.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4665.67 1074.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4662.17 1076.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4657.5 1074.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4658.67 1069.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.33336,
    transform: "matrix(-1 0 0 1 4662.17 1073)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4735.5 1058.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4736.67 1063.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4733.17 1065.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4728.5 1063.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 4729.67 1058.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.33336,
    transform: "matrix(-1 0 0 1 4733.17 1062)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5471.15 1030.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5472.62 1036.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5468.23 1039.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5462.38 1036.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5463.85 1030.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 5468.23 1034.77)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4988.51,
    cy: 1054.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4986.63,
    cy: 1062.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4992.27,
    cy: 1065.9,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4999.78,
    cy: 1062.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4997.9,
    cy: 1054.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4992.27,
    cy: 1060.27,
    r: 3.75642,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4818.51,
    cy: 1058.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4816.63,
    cy: 1066.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4822.27,
    cy: 1069.9,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4829.78,
    cy: 1066.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4827.9,
    cy: 1058.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4822.27,
    cy: 1064.27,
    r: 3.75642,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5685.9,
    cy: 1033.92,
    r: 5.53846,
    transform: "rotate(46.9377 5685.9 1033.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5679.24,
    cy: 1037.62,
    r: 5.53846,
    transform: "rotate(46.9377 5679.24 1037.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5680.33,
    cy: 1044.18,
    r: 5.53846,
    transform: "rotate(46.9377 5680.33 1044.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5688.06,
    cy: 1047.06,
    r: 5.53846,
    transform: "rotate(46.9377 5688.06 1047.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5692.2,
    cy: 1040.67,
    r: 5.53846,
    transform: "rotate(46.9377 5692.2 1040.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5684.37,
    cy: 1040.4,
    r: 3.69231,
    transform: "rotate(46.9377 5684.37 1040.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5288.39 1046.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5295.05 1050.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5293.96 1057.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5286.23 1060.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5282.09 1053.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5289.92 1053.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5144.39 1051.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5151.05 1054.87)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5149.96 1061.44)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5142.23 1064.31)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5138.09 1057.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5145.92 1057.66)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5874.38,
    cy: 994.538,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5872.54,
    cy: 1001.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5878.08,
    cy: 1005.62,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5885.46,
    cy: 1001.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5883.61,
    cy: 994.538,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5878.08,
    cy: 1000.08,
    r: 3.69231,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6001 1025)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6002 1029)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5999 1031)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5995 1029)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5996 1025)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 5999 1028)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6207 1011)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6208 1015)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6205 1017)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6201 1015)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6202 1011)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 6205 1014)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6464.71,
    cy: 1024,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6463.71,
    cy: 1028,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6466.71,
    cy: 1030,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6470.71,
    cy: 1028,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6469.71,
    cy: 1024,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6466.71,
    cy: 1027,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6603,
    cy: 1056,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6602,
    cy: 1060,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6605,
    cy: 1062,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6609,
    cy: 1060,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6608,
    cy: 1056,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6605,
    cy: 1059,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6085.46 999.881)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6091.31 1004.76)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6089.01 1011.01)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6080.87 1012.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6078.01 1005.32)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6085.75 1006.53)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6266.62 1037.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6268.46 1044.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6262.92 1048.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6255.54 1044.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6257.39 1037.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 6262.92 1043.08)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6408.38,
    cy: 1042.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6406.54,
    cy: 1049.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6412.08,
    cy: 1053.62,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6419.46,
    cy: 1049.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6417.61,
    cy: 1042.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6412.08,
    cy: 1048.08,
    r: 3.69231,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 6765.28 1060.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 6766.46 1065.26)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 6762.92 1067.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 6758.21 1065.26)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 6759.39 1060.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.35897,
    transform: "matrix(-1 0 0 1 6762.92 1064.08)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6308.15 1006.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6309.62 1012.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6305.23 1015.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6299.38 1012.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6300.85 1006.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 6305.23 1010.77)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6906.5,
    cy: 1046.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6905.33,
    cy: 1051.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6908.83,
    cy: 1053.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6913.5,
    cy: 1051.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6912.33,
    cy: 1046.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6908.83,
    cy: 1050,
    r: 2.33336,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7158.5,
    cy: 1065.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7157.33,
    cy: 1070.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7160.83,
    cy: 1072.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7165.5,
    cy: 1070.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7164.33,
    cy: 1065.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7160.83,
    cy: 1069,
    r: 2.33336,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7087.5,
    cy: 1054.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7086.33,
    cy: 1059.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7089.83,
    cy: 1061.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7094.5,
    cy: 1059.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7093.33,
    cy: 1054.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7089.83,
    cy: 1058,
    r: 2.33336,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6351.85,
    cy: 1026.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6350.38,
    cy: 1032.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6354.77,
    cy: 1035.15,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6360.62,
    cy: 1032.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6359.15,
    cy: 1026.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6354.77,
    cy: 1030.77,
    r: 2.92308,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 6834.49 1050.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 6836.37 1058.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 6830.73 1061.9)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 6823.22 1058.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 6825.1 1050.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.75642,
    transform: "matrix(-1 0 0 1 6830.73 1056.27)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 7004.49 1054.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 7006.37 1062.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 7000.73 1065.9)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 6993.22 1062.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 6995.1 1054.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.75642,
    transform: "matrix(-1 0 0 1 7000.73 1060.27)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6137.1 1029.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6143.76 1033.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6142.67 1040.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6134.94 1043.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6130.8 1036.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6138.63 1036.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6534.61,
    cy: 1042.92,
    r: 5.53846,
    transform: "rotate(46.9377 6534.61 1042.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6527.95,
    cy: 1046.62,
    r: 5.53846,
    transform: "rotate(46.9377 6527.95 1046.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6529.04,
    cy: 1053.18,
    r: 5.53846,
    transform: "rotate(46.9377 6529.04 1053.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6536.77,
    cy: 1056.06,
    r: 5.53846,
    transform: "rotate(46.9377 6536.77 1056.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6540.91,
    cy: 1049.67,
    r: 5.53846,
    transform: "rotate(46.9377 6540.91 1049.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6533.08,
    cy: 1049.4,
    r: 3.69231,
    transform: "rotate(46.9377 6533.08 1049.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6678.61,
    cy: 1047.18,
    r: 5.53846,
    transform: "rotate(46.9377 6678.61 1047.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6671.95,
    cy: 1050.87,
    r: 5.53846,
    transform: "rotate(46.9377 6671.95 1050.87)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6673.04,
    cy: 1057.44,
    r: 5.53846,
    transform: "rotate(46.9377 6673.04 1057.44)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6680.77,
    cy: 1060.31,
    r: 5.53846,
    transform: "rotate(46.9377 6680.77 1060.31)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6684.91,
    cy: 1053.92,
    r: 5.53846,
    transform: "rotate(46.9377 6684.91 1053.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6677.08,
    cy: 1053.66,
    r: 3.69231,
    transform: "rotate(46.9377 6677.08 1053.66)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5948.62 990.538)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5950.46 997.923)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5944.92 1001.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5937.54 997.923)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5939.39 990.538)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 5944.92 996.077)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12463.1 1052.08C12420.3 1067.12 12077 1071.19 12057 1088H12155.5H13720.5V936C13658.3 943.24 13486.8 973.388 13354.7 976.061C13189.7 979.402 13082 1042.05 13007.5 1033.5C12983.1 1030.69 12860.4 1052.08 12755.5 1042.05C12650.5 1032.03 12505.8 1037.04 12463.1 1052.08Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13843 1029)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13844 1033)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13841 1035)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13837 1033)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13838 1029)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 13841 1032)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 14049 1015)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 14050 1019)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 14047 1021)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 14043 1019)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 14044 1015)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 14047 1018)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14306.7,
    cy: 1028,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14305.7,
    cy: 1032,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14308.7,
    cy: 1034,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14312.7,
    cy: 1032,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14311.7,
    cy: 1028,
    r: 3,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14308.7,
    cy: 1031,
    r: 2,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13927.5 1003.88)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13933.3 1008.76)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13931 1015.01)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13922.9 1016.38)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13920 1009.32)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13927.7 1010.53)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13863.2 978.827)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13869.1 983.704)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13866.8 989.951)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13858.6 991.323)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13855.8 984.269)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13863.5 985.478)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14108.6 1041.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14110.5 1048.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14104.9 1052.62)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14097.5 1048.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14099.4 1041.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 14104.9 1047.08)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14250.4,
    cy: 1046.54,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14248.5,
    cy: 1053.92,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14254.1,
    cy: 1057.62,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14261.5,
    cy: 1053.92,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14259.6,
    cy: 1046.54,
    r: 5.53846,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14254.1,
    cy: 1052.08,
    r: 3.69231,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14150.2 1010.38)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14151.6 1016.23)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14147.2 1019.15)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14141.4 1016.23)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14142.8 1010.38)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 14147.2 1014.77)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14193.8,
    cy: 1030.38,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14192.4,
    cy: 1036.23,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14196.8,
    cy: 1039.15,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14202.6,
    cy: 1036.23,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14201.2,
    cy: 1030.38,
    r: 4.38462,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14196.8,
    cy: 1034.77,
    r: 2.92308,
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13979.1 1033.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13985.8 1037.62)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13984.7 1044.18)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13976.9 1047.06)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13972.8 1040.67)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13980.6 1040.4)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13790.6 994.538)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13792.5 1001.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13786.9 1005.62)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13779.5 1001.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13781.4 994.538)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 13786.9 1000.08)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13766.6 1037.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13768.5 1044.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13762.9 1048.62)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13755.5 1044.92)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13757.4 1037.54)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 13762.9 1043.08)",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14977.4 1052.08C15020.2 1067.12 15363.5 1071.19 15383.5 1088H15285H13720V936C13782.2 943.24 13953.7 973.388 14085.8 976.061C14250.8 979.402 14358.5 1042.05 14433 1033.5C14457.4 1030.69 14580.1 1052.08 14685 1042.05C14790 1032.03 14934.7 1037.04 14977.4 1052.08Z",
    fill: "#3A9D7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13587,
    cy: 1038,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13586,
    cy: 1042,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13589,
    cy: 1044,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13593,
    cy: 1042,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13592,
    cy: 1038,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13589,
    cy: 1041,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13381,
    cy: 1024,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13380,
    cy: 1028,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13383,
    cy: 1030,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13387,
    cy: 1028,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13386,
    cy: 1024,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13383,
    cy: 1027,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13123.3 1037)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13124.3 1041)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13121.3 1043)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13117.3 1041)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13118.3 1037)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 13121.3 1040)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12985 1069)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12986 1073)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12983 1075)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12979 1073)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12980 1069)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 12983 1072)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13502.5,
    cy: 1012.88,
    r: 5.53846,
    transform: "rotate(36.1252 13502.5 1012.88)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13496.7,
    cy: 1017.76,
    r: 5.53846,
    transform: "rotate(36.1252 13496.7 1017.76)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13499,
    cy: 1024.01,
    r: 5.53846,
    transform: "rotate(36.1252 13499 1024.01)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13507.1,
    cy: 1025.38,
    r: 5.53846,
    transform: "rotate(36.1252 13507.1 1025.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13510,
    cy: 1018.32,
    r: 5.53846,
    transform: "rotate(36.1252 13510 1018.32)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13502.3,
    cy: 1019.53,
    r: 3.69231,
    transform: "rotate(36.1252 13502.3 1019.53)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13321.4,
    cy: 1050.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13319.5,
    cy: 1057.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13325.1,
    cy: 1061.62,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13332.5,
    cy: 1057.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13330.6,
    cy: 1050.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13325.1,
    cy: 1056.08,
    r: 3.69231,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13179.6 1055.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13181.5 1062.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13175.9 1066.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13168.5 1062.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13170.4 1055.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 13175.9 1061.08)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12822.7,
    cy: 1073.54,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12821.5,
    cy: 1078.26,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12825.1,
    cy: 1080.62,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12829.8,
    cy: 1078.26,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12828.6,
    cy: 1073.54,
    r: 3.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12825.1,
    cy: 1077.08,
    r: 2.35897,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13279.8,
    cy: 1019.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13278.4,
    cy: 1025.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13282.8,
    cy: 1028.15,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13288.6,
    cy: 1025.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13287.2,
    cy: 1019.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13282.8,
    cy: 1023.77,
    r: 2.92308,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12681.5 1059.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12682.7 1064.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12679.2 1066.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12674.5 1064.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12675.7 1059.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.33336,
    transform: "matrix(-1 0 0 1 12679.2 1063)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12429.5 1078.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12430.7 1083.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12422.5 1083.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12423.7 1078.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.33336,
    transform: "matrix(-1 0 0 1 12427.2 1082)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12500.5 1067.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12501.7 1072.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12498.2 1074.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12493.5 1072.17)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.50004,
    transform: "matrix(-1 0 0 1 12494.7 1067.5)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.33336,
    transform: "matrix(-1 0 0 1 12498.2 1071)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 13236.2 1039.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 13237.6 1045.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 13233.2 1048.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 13227.4 1045.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 13228.8 1039.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 13233.2 1043.77)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12753.5,
    cy: 1063.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12751.6,
    cy: 1071.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12757.3,
    cy: 1074.9,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12764.8,
    cy: 1071.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12762.9,
    cy: 1063.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12757.3,
    cy: 1069.27,
    r: 3.75642,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12583.5,
    cy: 1067.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12581.6,
    cy: 1075.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12587.3,
    cy: 1078.9,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12594.8,
    cy: 1075.15,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12592.9,
    cy: 1067.63,
    r: 5.63463,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12587.3,
    cy: 1073.27,
    r: 3.75642,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13450.9,
    cy: 1042.92,
    r: 5.53846,
    transform: "rotate(46.9377 13450.9 1042.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13444.2,
    cy: 1046.62,
    r: 5.53846,
    transform: "rotate(46.9377 13444.2 1046.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13445.3,
    cy: 1053.18,
    r: 5.53846,
    transform: "rotate(46.9377 13445.3 1053.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13453.1,
    cy: 1056.06,
    r: 5.53846,
    transform: "rotate(46.9377 13453.1 1056.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13457.2,
    cy: 1049.67,
    r: 5.53846,
    transform: "rotate(46.9377 13457.2 1049.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13449.4,
    cy: 1049.4,
    r: 3.69231,
    transform: "rotate(46.9377 13449.4 1049.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13053.4 1055.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13060 1059.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13059 1066.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13051.2 1069.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13047.1 1062.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13054.9 1062.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 12909.4 1060.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 12916 1063.87)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 12915 1070.44)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 12907.2 1073.31)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 12903.1 1066.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 12910.9 1066.66)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13639.4,
    cy: 1003.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13637.5,
    cy: 1010.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13643.1,
    cy: 1014.62,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13650.5,
    cy: 1010.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13648.6,
    cy: 1003.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13643.1,
    cy: 1009.08,
    r: 3.69231,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13766 1034)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13767 1038)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13764 1040)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13760 1038)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13761 1034)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 13764 1037)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13972 1020)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13973 1024)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13970 1026)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13966 1024)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 13967 1020)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 13970 1023)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14229.7,
    cy: 1033,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14228.7,
    cy: 1037,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14231.7,
    cy: 1039,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14235.7,
    cy: 1037,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14234.7,
    cy: 1033,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14231.7,
    cy: 1036,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14368,
    cy: 1065,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14367,
    cy: 1069,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14370,
    cy: 1071,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14374,
    cy: 1069,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14373,
    cy: 1065,
    r: 3,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14370,
    cy: 1068,
    r: 2,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13850.5 1008.88)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13856.3 1013.76)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13854 1020.01)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13845.9 1021.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13843 1014.32)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 13850.7 1015.53)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14031.6 1046.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14033.5 1053.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14027.9 1057.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14020.5 1053.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 14022.4 1046.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 14027.9 1052.08)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14173.4,
    cy: 1051.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14171.5,
    cy: 1058.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14177.1,
    cy: 1062.62,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14184.5,
    cy: 1058.92,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14182.6,
    cy: 1051.54,
    r: 5.53846,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14177.1,
    cy: 1057.08,
    r: 3.69231,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 14530.3 1069.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 14531.5 1074.26)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 14527.9 1076.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 14523.2 1074.26)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.53846,
    transform: "matrix(-1 0 0 1 14524.4 1069.54)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.35897,
    transform: "matrix(-1 0 0 1 14527.9 1073.08)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14073.2 1015.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14074.6 1021.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14070.2 1024.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14064.4 1021.23)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 14065.8 1015.38)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 14070.2 1019.77)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14671.5,
    cy: 1055.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14670.3,
    cy: 1060.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14673.8,
    cy: 1062.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14678.5,
    cy: 1060.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14677.3,
    cy: 1055.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14673.8,
    cy: 1059,
    r: 2.33336,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14923.5,
    cy: 1074.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14922.3,
    cy: 1079.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14925.8,
    cy: 1081.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14930.5,
    cy: 1079.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14929.3,
    cy: 1074.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14925.8,
    cy: 1078,
    r: 2.33336,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14852.5,
    cy: 1063.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14851.3,
    cy: 1068.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14854.8,
    cy: 1070.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14859.5,
    cy: 1068.17,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14858.3,
    cy: 1063.5,
    r: 3.50004,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14854.8,
    cy: 1067,
    r: 2.33336,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14116.8,
    cy: 1035.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14115.4,
    cy: 1041.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14119.8,
    cy: 1044.15,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14125.6,
    cy: 1041.23,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14124.2,
    cy: 1035.38,
    r: 4.38462,
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14119.8,
    cy: 1039.77,
    r: 2.92308,
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14599.5 1059.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14601.4 1067.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14595.7 1070.9)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14588.2 1067.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14590.1 1059.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.75642,
    transform: "matrix(-1 0 0 1 14595.7 1065.27)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14769.5 1063.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14771.4 1071.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14765.7 1074.9)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14758.2 1071.15)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.63463,
    transform: "matrix(-1 0 0 1 14760.1 1063.63)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.75642,
    transform: "matrix(-1 0 0 1 14765.7 1069.27)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13902.1 1038.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13908.8 1042.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13907.7 1049.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13899.9 1052.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13895.8 1045.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 13903.6 1045.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14299.6,
    cy: 1051.92,
    r: 5.53846,
    transform: "rotate(46.9377 14299.6 1051.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14293,
    cy: 1055.62,
    r: 5.53846,
    transform: "rotate(46.9377 14293 1055.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14294,
    cy: 1062.18,
    r: 5.53846,
    transform: "rotate(46.9377 14294 1062.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14301.8,
    cy: 1065.06,
    r: 5.53846,
    transform: "rotate(46.9377 14301.8 1065.06)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14305.9,
    cy: 1058.67,
    r: 5.53846,
    transform: "rotate(46.9377 14305.9 1058.67)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14298.1,
    cy: 1058.4,
    r: 3.69231,
    transform: "rotate(46.9377 14298.1 1058.4)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14443.6,
    cy: 1056.18,
    r: 5.53846,
    transform: "rotate(46.9377 14443.6 1056.18)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14437,
    cy: 1059.87,
    r: 5.53846,
    transform: "rotate(46.9377 14437 1059.87)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14438,
    cy: 1066.44,
    r: 5.53846,
    transform: "rotate(46.9377 14438 1066.44)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14445.8,
    cy: 1069.31,
    r: 5.53846,
    transform: "rotate(46.9377 14445.8 1069.31)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14449.9,
    cy: 1062.92,
    r: 5.53846,
    transform: "rotate(46.9377 14449.9 1062.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14442.1,
    cy: 1062.66,
    r: 3.69231,
    transform: "rotate(46.9377 14442.1 1062.66)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13713.6 999.538)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13715.5 1006.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13709.9 1010.62)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13702.5 1006.92)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 13704.4 999.538)",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 13709.9 1005.08)",
    fill: "#FFE872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7591 967C7555.98 974.095 7525.85 984.699 7506.87 993.377C7474.48 1008.17 7452.03 1018.8 7438.52 1043.49C7430.31 1058.47 7428.37 1073.22 7428 1083.06C7482.34 1083.06 7536.66 1083.06 7591 1083.06V967Z",
    fill: "#F5B2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7554.1 856.519L7584.15 889.697C7585.72 891.427 7588.4 891.56 7590.13 889.987C7591.86 888.414 7591.99 885.74 7590.42 884.01L7560.38 850.832C7558.8 849.102 7556.13 848.969 7554.4 850.542C7552.66 852.103 7552.52 854.789 7554.1 856.519Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7593.8 869.494L7627.76 835.554C7629.41 833.896 7629.41 831.222 7627.76 829.565C7626.1 827.907 7623.43 827.907 7621.77 829.565L7587.82 863.517C7586.16 865.174 7586.16 867.848 7587.82 869.506C7589.47 871.152 7592.16 871.152 7593.8 869.494Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.19 988.237C7591.2 988.237 7592.82 986.616 7592.82 984.607V817.63C7592.82 815.621 7591.2 814 7589.19 814C7587.18 814 7585.56 815.621 7585.56 817.63V984.607C7585.56 986.616 7587.18 988.237 7589.19 988.237Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19199.5 1022C19131.7 1047.29 19089.3 1074.07 19081 1079.56H19199.5V1022Z",
    fill: "#3A9D7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8658,
    y1: 647.181,
    x2: 8658,
    y2: 1220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#35359F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823923,
    stopColor: "#05ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872917,
    stopColor: "#00718F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10872,
    y1: 607.181,
    x2: 10872,
    y2: 1180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#35359F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823923,
    stopColor: "#05ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872917,
    stopColor: "#00718F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16275,
    y1: 771.346,
    x2: 16275,
    y2: 1216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.602083,
    stopColor: "#069FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794792,
    stopColor: "#00718F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19200,
    height: 1080,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrassAndTrees);
export default __webpack_public_path__ + "static/media/GrassAndTrees.60101c3c.svg";
export { ForwardRef as ReactComponent };